import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import dictionary from "@/i18n/translations";

const I18nContext = createContext(null);

const STORAGE_KEY = "mnah_lang";

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    return window.localStorage.getItem(STORAGE_KEY) || "en";
  });

  const setLang = useCallback((next) => {
    setLangState(next);
    try { window.localStorage.setItem(STORAGE_KEY, next); } catch (_) {}
  }, []);

  const toggle = useCallback(() => {
    setLang(lang === "en" ? "ar" : "en");
  }, [lang, setLang]);

  useEffect(() => {
    const pack = dictionary[lang] || dictionary.en;
    document.documentElement.lang = pack.code;
    document.documentElement.dir = pack.dir;
    // Body class so we can scope font-family + specific rtl adjustments
    if (pack.dir === "rtl") {
      document.body.classList.add("rtl");
    } else {
      document.body.classList.remove("rtl");
    }
  }, [lang]);

  const value = useMemo(() => {
    const pack = dictionary[lang] || dictionary.en;
    return { lang, setLang, toggle, t: pack, dir: pack.dir };
  }, [lang, setLang, toggle]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within <I18nProvider>");
  return ctx;
}
